import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Box, Button, Divider, Table, TableBody, TableCell, TableRow, TableHead
} from "@mui/material";

// Calificación general (SuggestedFeedbackSection)
const scoreToQualitativeMap = {
  5: "1 - Excede ampliamente las expectativas",
  4: "2 - Desempeño por encima del esperado",
  3: "3 - Desempeño esperado",
  2: "4 - Desempeño por debajo del esperado",
  1: "5 - Bastante alejado del esperado"
};
// Tareas (TasksSection)
const tasksLikert = {
  5: "Excedió ampliamente las expectativas",
  4: "Superó las expectativas",
  3: "Cumplió satisfactoriamente",
  2: "Cumplió parcialmente",
  1: "No cumplió"
};
// Valores (ValuesSection)
const valuesLikert = {
  4: "Lo demostró en un nivel excepcional",
  3: "Lo demostró consistentemente",
  2: "Lo demostró de manera ocasional",
  1: "No lo demostró"
};

export default function EvaluationDetailModal({ open, onClose, evaluation }) {
  if (!evaluation) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Detalle de Evaluación — {evaluation.period} — {scoreToQualitativeMap[evaluation.score] || "Sin calificación"}
      </DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <Typography variant="subtitle2" color="text.secondary">
            Evaluador: {evaluation.evaluador}
          </Typography>
        </Box>
        <Box mb={2}>
          <Typography variant="h6" color="primary">Objetivos</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Descripción</TableCell>
                <TableCell align="center">% Cumplimiento</TableCell>
                <TableCell>Comentarios</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {evaluation.objetivos?.map((obj, i) => (
                <TableRow key={i}>
                  <TableCell>{obj.description}</TableCell>
                  <TableCell align="center">{obj.achievement}%</TableCell>
                  <TableCell>{obj.comment}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Box mb={2}>
          <Typography variant="h6" color="primary">Tareas</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Descripción</TableCell>
                <TableCell align="center">Puntaje</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {evaluation.tareas?.map((task, i) => (
                <TableRow key={i}>
                  <TableCell>{task.description}</TableCell>
                  <TableCell align="center">{tasksLikert[task.rating] || task.rating}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Box mb={2}>
          <Typography variant="h6" color="primary">Valores</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Valor</TableCell>
                <TableCell>Descripción</TableCell>
                <TableCell align="center">Puntaje</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {evaluation.valores?.map((val, i) => (
                <TableRow key={i}>
                  <TableCell>{val.key}</TableCell>
                  <TableCell>{val.description}</TableCell>
                  <TableCell align="center">{valuesLikert[val.rating] || val.rating}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Box mb={2}>
          <Typography variant="h6" color="primary">Comentarios Generales</Typography>
          <Typography variant="body1" sx={{ pl: 2 }}>{evaluation.comentariosGenerales}</Typography>
        </Box>
        {evaluation.historialComentariosDeliveryManager && evaluation.area === 'Delivery & Tech' && (
          <Box mb={2}>
            <Typography variant="h6" color="primary">Historial de comentarios del Delivery Manager</Typography>
            {evaluation.historialComentariosDeliveryManager.map((item, idx) => (
              <Box key={idx} sx={{ pl: 2, mb: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  {item.fecha} — {item.autor}
                </Typography>
                <Typography variant="body2">{item.comentario}</Typography>
              </Box>
            ))}
          </Box>
        )}
        <Divider sx={{ my: 2 }} />
        <Box mb={2}>
          <Typography variant="h6" color="primary">Autoevaluación</Typography>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }}>Fortalezas</Typography>
          <Typography variant="body1" sx={{ pl: 2, mb: 1 }} whiteSpace="pre-line">
            {evaluation.autoevaluacion?.strengths}
          </Typography>
          <Typography variant="subtitle1" fontWeight="bold">Áreas de Mejora</Typography>
          <Typography variant="body1" sx={{ pl: 2 }} whiteSpace="pre-line">
            {evaluation.autoevaluacion?.areasOfImprovement}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
} 